export default "__VITE_ASSET__174dd3b2__"